import { getScenarioRoleId } from 'services/scenariosApi';
import type { BackendScenario } from 'services/scenariosApi';

const ROLE_ALIASES: Record<string, string> = {
  operation_manager: 'ops',
  operations_manager: 'ops',
  operational_manager: 'ops',
  ops: 'ops',
  hr: 'hr',
  human_resources: 'hr',
  lawyer: 'lawyer',
  legal: 'lawyer',
  admin: 'admin',
};

export const normalizeRoleKey = (role: string): string => {
  const key = role.trim().toLowerCase();
  return ROLE_ALIASES[key] ?? key;
};

export const getScenarioRoleKey = (scenario: BackendScenario): string => {
  const roleName = scenario.role?.name;
  return normalizeRoleKey(roleName || getScenarioRoleId(scenario) || 'unknown');
};
